import { render, staticRenderFns } from "./morebar.vue?vue&type=template&id=523ce388&scoped=true&"
import script from "./morebar.vue?vue&type=script&lang=js&"
export * from "./morebar.vue?vue&type=script&lang=js&"
import style0 from "./morebar.vue?vue&type=style&index=0&id=523ce388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ce388",
  null
  
)

export default component.exports